import React, { useState, useEffect } from 'react';
import { extractWorkbook, leerHojaExcel, procesarJSONtemperaturas } from '../../../sharecomponents/ExelProccessorUtility';
import { soloFechacorto } from '../../../../utils/FechasTraductores';
import Post from '../../../../utils/Post';
import Verifiers from '../../../../utils/Verifiers.jsx';
import LineaDeAvance from '../NETJET/componentes/LineaDeAvance';
import VainillaDialog from '../../../sharecomponents/vanilladialog';

const CargasTemperaturaExcel = () => {
    const [excelDocumento, setexcelDocumento] = useState({ libro: null, hoja: "", hojas: [], datos: [] });
    const [cargaControl, setcargaControl] = useState({ cargando: false, avance: 0 });
    const [loader, setloader] = useState(false);
    var interrumpirCarga = false;
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [desfaseDias, setdesfaseDias] = useState(0);
    var counter = 0;
    const normalInputClass = 'form-control form-control-sm round-xxl shadow';
    const normalLabelClass = 'text-bold ps-2';
    const focusLableClass = 'text-bold ps-2 scale-continue-05 text-danger';
    const focusInputClass = 'form-control form-control-sm round-xxl shadow border border-warning';
    const encabezados = [
        { key: 'fecha', value: 'Fecha' },
        { key: 'maxTemperatura', value: 'Temperatura Máxima' },
        { key: 'minTemperatura', value: 'Temperatura Mínima' },
        { key: 'evapotranspiracion', value: 'Evapotranspiración' }];

    useEffect(() => {

    }, []);

    const cargarLibroExcel = (e) => {
        extractWorkbook(e, (worbook) => { setexcelDocumento({ libro: worbook.workbook, hoja: "", hojas: worbook.hojas, datos: [] }) }, setdialog, setloader);
    }

    const cargarHoja = (e) => {
        let hoja = e.target.value;
        exttraerDatosExel(hoja);
    }

    const exttraerDatosExel = (hoja = excelDocumento.hoja, desfase = desfaseDias) => {
        let jsons = leerHojaExcel(excelDocumento.libro, hoja);
        if (jsons.length == 0) return setexcelDocumento({ libro: excelDocumento.libro, hoja: hoja, hojas: excelDocumento.hojas, datos: [] });
        let jsonsProcesado = procesarJSONtemperaturas(jsons, desfase);
        setexcelDocumento({ libro: excelDocumento.libro, hoja: hoja, hojas: excelDocumento.hojas, datos: jsonsProcesado });
    }

    const ajustarDefase = (add = false) => {
        let desfase = desfaseDias;
        if (add) desfase++;
        else desfase--;
        exttraerDatosExel(excelDocumento.hoja, desfase);
        setdesfaseDias(desfase);

    }

    const mensajeIntruccion = () => {
        if (!excelDocumento.libro) return (<div className='w-100 mt-4 text-center h3 text-300'>Para empezar seleccione un archivo excel de su dispositivo usando control
            <span className='text-bold ms-2'>Seleccionar archivo excel</span></div>);
        if (excelDocumento.libro && excelDocumento.hojas.length == 0) return (
            <div className='w-100 mt-4 text-center h3 text-300'>No se encontraron hojas de excel procesables en el archivo seleccionado</div>
        )
        if (excelDocumento.libro && excelDocumento.hojas.length > 0 && excelDocumento.hoja === "") return (
            <div className='w-100 mt-4 text-center h3 text-300'>
                <span className='text-bold ms-2'>Seleccione una hoja</span> de excel para continuar
            </div>
        )
        if (excelDocumento.libro && excelDocumento.hojas.length > 0 && excelDocumento.hoja != "" && excelDocumento.datos.length == 0) return (
            <div className='w-100 mt-4 text-center h3 text-300 text-red3'>
                <span className='text-bold ms-2'>No se encontraron datos útiles</span> en la hoja seleccionada
            </div>
        )
    }

    const keygen = () => { counter++; return counter; }

    const enviarAServidor = async () => {
        let slice = 300;
        let errores = 0;
        let correctos = 0;
        let len = excelDocumento.datos.length;
        let cargaError = false;
        let control = { cargando: true, avance: 0 }
        setcargaControl({ ...control });

        for (let i = 0; i < len && control.cargando; i += slice) {
            let arrSlice = excelDocumento.datos.slice(i, i + slice);
            let resp = await Post('/api/general/gradosDias/masivo', { data: arrSlice }, 'POST', false);

            if (!resp.estatus) {
                Verifiers.activeDialog(setdialog, resp.msj, 'error', 'Error');
                cargaError = true;
                control.cargando = false;
                break;
            }

            correctos += resp.data.correctos;
            errores += resp.data.errores;
            control.avance = Math.round((i + slice) * 100 / len);
            setcargaControl({ ...control });
        }
        interrumpirCarga = false;
        setcargaControl({ cargando: false, avance: 0 });
        if (!cargaError) {
            Verifiers.activeDialog(setdialog, `Se cargaron ${correctos} registros correctamente y se encontraron ${errores} errores`, 'Carga de datos', 'success');
            setexcelDocumento({ ...excelDocumento, datos: [], hoja: "" });
        }
    }

    return (
        <div className='vw-100 p-2 overflow bg-white p-2 dosis overflow' style={{ height: "calc( 100vh - 60px)" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='bw-300'>
                    <label className={excelDocumento.libro ? normalLabelClass : focusLableClass}>Seleccionar archivo excel</label>
                    <input type='file' className={excelDocumento.libro ? normalInputClass : focusInputClass} onChange={cargarLibroExcel}
                        placeholder='Cargar archivo'
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                </div>
                <div className='bw-300'>
                    {excelDocumento.libro && excelDocumento.hojas.length > 0 && <>
                        <label className={excelDocumento.hoja != "" ? normalLabelClass : focusLableClass}>Seleccionar hoja a cargar</label>
                        <select className={excelDocumento.hoja != "" ? normalInputClass : focusInputClass}
                            value={excelDocumento.hoja}
                            onChange={cargarHoja}>
                            <option value='' >Seleccione una</option>
                            {excelDocumento.hojas.map((hoja) => <option key={keygen()} value={hoja} >{hoja}</option>)}
                        </select>
                    </>}

                </div>
                <div className='bw-300'>
                    {excelDocumento.datos.length > 0 && <>
                        <label className='w-100 text-green4 ms-2 text-bold'>{excelDocumento.datos.length} Registros encontrados</label>
                        <button className='btn btn-light btn-sm scale-continue-05 contenedor border-3 border border-success round-xxl text-bold shadow w-100'
                            onClick={enviarAServidor}>Guardar Registros</button>
                    </>}

                </div>
                <div className='bw-200'>
                    {excelDocumento.datos.length > 0 && <>
                        <label className='w-100 text-bold text-center'>Ajuste desfase de días</label>
                        <div className='row justify-content-evenly w-100 m-0 p-0'>
                            <div className='w-30 m-0 p-1 round-left-xxl contenedor shadow-multi-hover pointer border bg-white border-warning '
                                onClick={() => ajustarDefase(false)}>-1</div>
                            <div className='w-40 m-0 contenedor border-top border-bottom '>
                                <span className='text-bold text-l me-1'>{desfaseDias}</span> Días
                            </div>
                            <div className='w-30 m-0 p-1 round-right-xxl contenedor shadow-multi-hover pointer border bg-white border-warning '
                                onClick={() => ajustarDefase(true)}>+1</div>
                        </div>
                    </>}

                </div>
                {mensajeIntruccion()}
                <div className='w-100 m-0 h-0 mt-3'></div>
                {excelDocumento.datos.length > 0 && <div className='bw-800 round-bottom-m shadow-sm border-bottom vh-80 overflow p-1 pt-0 border'>
                    <table className='table table-sm'>
                        <thead>
                            <tr>
                                {encabezados.map((encabezado) => <th key={keygen()} scope='col' className='nowrap text-center bg-black text-white'>{encabezado.value}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {excelDocumento.datos.map((dato, i) => <tr key={keygen()}>
                                {encabezados.map((encabezado) => <td className='nowrap text-center p-0' key={keygen()}>
                                    {encabezado.key === 'fecha' ? soloFechacorto(dato[encabezado.key]) : dato[encabezado.key]}
                                </td>)}
                            </tr>)}
                        </tbody>
                    </table>
                </div>}
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
            {cargaControl.cargando && <div className='vh-100 vw-100 blur-s contenedor' style={{ zIndex: 999, position: "fixed", top: 0, left: 0 }}>
                <div className='row justify-content-evenly w-100 m-0 p-0'>
                    <div className='w-100 text-center text-bold h4'>Guardando registros, avance : {cargaControl.avance}%</div>
                    <LineaDeAvance avance={cargaControl.avance} height={7.5} bwWidth="bw-1200 shadow" />

                </div>
            </div>}


        </div>
    )
}

export default CargasTemperaturaExcel;